import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { BaseFormation } from '../base-formation';
import { GenericData, CatalogsModel, Catalog } from '../../shared';
import { EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  selector: 'webstore-catalogs',
  templateUrl: './catalogs.component.html',
  styleUrls: ['./catalogs.component.css']
})

export class CatalogsComponent extends BaseFormation implements OnInit {

  public catalogs: GenericData<Catalog>[];

  constructor(
    public store: StoreService,
    protected http: HttpClient,
    protected router: Router
  ) { super(store); }

  ngOnInit(): void {
    this.store.showSplash(true);
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/catalogue/V2/INITDATA/0`;
    this.http.get<CatalogsModel>(destUrl).subscribe((data: CatalogsModel): void => {
      if (!data.HasError) {
        if (data.CatalogueList.length === 0)
          this.store.warning(this.store.getTrad('nocatalogs'));
        else
          this.catalogs = this.store.convertList<Catalog>(data.CatalogueList, 2);
      }
      this.store.showSplash(false);
    }, (error: any): void => { JSON.stringify(error); });
  }

  selectCatalog(catalog: Catalog): void {
    if (catalog.TotCategories === 0)
      this.store.warning(this.store.getTrad('nocategory'));
    else {
      super.setCatalog(catalog);
      this.router.navigateByUrl(this.store.AppRoutes.CATEGORIES);
    }
  }
}
